import { Menu } from 'lucide-react'
import type { ReactNode } from 'react'

export interface AppTopbarProps {
  /** Left side content (e.g. startup switcher, panel label) */
  left?: ReactNode
  /** Right side content (e.g. user menu) */
  right?: ReactNode
  /** Notifications widget (e.g. NotificationsPopup). Rendered before `right`. */
  notifications?: ReactNode
  /** Called when the mobile hamburger menu is tapped. Only rendered on mobile (<lg). */
  onMenuClick?: () => void
}

export function AppTopbar({ left, right, notifications, onMenuClick }: AppTopbarProps) {
  return (
    <header className="z-30 flex h-14 shrink-0 items-center justify-between border-b border-border bg-[#111111] px-4 lg:px-6">
      <div className="flex items-center gap-2">
        {onMenuClick && (
          <button
            type="button"
            onClick={onMenuClick}
            className="flex size-9 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-white/[0.04] hover:text-foreground lg:hidden"
          >
            <Menu className="size-5" />
          </button>
        )}
        {left}
      </div>
      <div className="flex items-center gap-3">
        {notifications}
        {right}
      </div>
    </header>
  )
}
